/**
 * @desc 分页
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  body: defs.fulfilment.TransferRequestParamsDto,
  params: API.fulfilment.transfer.page.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/transfer/page`, {
      method: "POST",
      params,
      data: body,
      ...options,
    }),
  );
}
